import { Button, Input, Modal, Select } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {
  updateDeviceManager,
  createDeviceManager,
} from "../../global/utility/Utils";
import ToastNotification from "../../global/components/ToastNotification";

const { Option } = Select;

const EditDevice = ({
  visible,
  onClose,
  onEditDeviceUpdate,
  selectedDevice,
}) => {
  const shouldRenderComponent =
    selectedDevice !== null && selectedDevice?.kind !== "ts.device.ble";
  const initialDeviceInfo = {
    name: selectedDevice?.name || "",
    description: selectedDevice?.description || "",
    kind: selectedDevice?.kind || "",
    assetType: selectedDevice?.customdata?.assetType || "",
    activestatus: selectedDevice?.customdata?.activestatus || "INACTIVE",
  };
  if (shouldRenderComponent) {
    initialDeviceInfo.targetDeviceProfile =
      selectedDevice?.customdata?.gatewayType || "Mobile";
  }
  if (selectedDevice === null) {
    initialDeviceInfo.kind = "ts.device.ble";
  }
  const [deviceInfo, setDeviceInfo] = useState(initialDeviceInfo);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [typeNotific, setTypeNotific] = useState("error");
  const [msgNotific, setMsgNotific] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    description: "",
    assetType: "",
  });

  const [hovered, setHovered] = useState(false);
  const [clicked] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setDeviceInfo({
      ...deviceInfo,
      [field]: value,
    });
    // Clear validation error when user starts typing
    setValidationErrors({
      ...validationErrors,
      [field]: "",
    });
  };

  const handleClick = () => {
    // Validate fields
    const errors = {};
    if (selectedDevice === null) {
      if (!deviceInfo.name.trim()) {
        errors.name = "Name is required.";
      } else if (!/^[A-Za-z]+:\d+$/.test(deviceInfo.name.trim())) {
        errors.name = "Name must be in the format anyText: followed by digits.";
      }
    } else {
      if (!deviceInfo.name.trim()) {
        errors.name = "Name is required.";
      }
    }
    if (!deviceInfo.description.trim()) {
      errors.description = "Description is required.";
    }
    // if (!deviceInfo.assetType) {
    //   errors.assetType = "Asset type is required.";
    // }
    
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
    } else {
      let payload = JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        name: deviceInfo.name,
        description: deviceInfo.description,
        customdata: {
          assetType: deviceInfo.assetType,
        },
      });
      if (selectedDevice === null) {
        let numberPart = deviceInfo.name.match(/:(\d+)$/);
        if (typeof payload === "string") {
          payload = JSON.parse(payload);
        }
        payload.kind = "ts.device.ble";
        payload.serial = numberPart[1];
        payload.refidtype = "serial";
        payload.refid = numberPart[1];
        payload.billingaccountid = sessionStorage.getItem("accountId");
        let jsonPayload = JSON.stringify(payload);
        createDeviceManager(jsonPayload).then((res) => {
          if (res?.customdata) {
            setShowNotification(true);
            setTypeNotific("success");
            setMsgNotific("Device Created successfully");
            setTimeout(() => {
              navigate("/devices");
            }, 1000);
          } else {
            setShowNotification(true);
            setTypeNotific("error");
            setMsgNotific("Invalid Data");
          }
        });
      } else {
        if (typeof payload === "string") {
          payload = JSON.parse(payload);
        }
        if (shouldRenderComponent) {
          payload.customdata.gatewayType = deviceInfo.targetDeviceProfile;
        }
        payload.device_id = selectedDevice?.uid;
        let jsonPayload = JSON.stringify(payload);
        // let jsonPayload = JSON.stringify({
        //   accountname: sessionStorage.getItem("accountId"),
        //   device:{
        //       customdata: {
        //         assetType: payload?.customdata?.assetType,
        //         gatewayType: payload?.customdata?.gatewayType
        //       },
        //       name:payload?.name,
        //       description:payload?.description,
        //   },
        //   resourceidentifier: {
        //     deviceid: payload?.device_id
        //   }
        // });
        updateDeviceManager(selectedDevice.uid, jsonPayload).then(
          (response) => {
            console.log("checkingresponse", response?.name);
            if (response?.name) {
              setNotificationProps({
                type: "success",
                message: "Device saved successfully",
                description: `Device "${response?.name}" updated successfully.`,
                duration: 3,
              });
              setShowNotification(true);
              setTimeout(() => {
                setShowNotification(false);
                onEditDeviceUpdate();
              }, 3000);
            } else {
              setNotificationProps({
                type: "error",
                message: "Failed to save device",
                description:
                  response?.error_description ||
                  "An error occurred while updating.",
                duration: 3,
              });
              setShowNotification(true);
              setTimeout(() => {
                setShowNotification(false);
              }, 3000);
            }
          }
        );
      }
    }
  };

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={600}>
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
      <div style={{ marginBottom: "10px" }}>
        <h2 className={"font-face-vzb page-heading-user"}>
          {selectedDevice === null ? "Add device" : "Edit device"}
        </h2>
        <br />
        <h4 className={"font-face-vzb page-sub-heading-user"}>Information</h4>
      </div>
      <Grid2 container spacing={2} direction="column">
        <Grid2 item xs={12}>
          <div>
            <span className="input-label-user">Name</span>
            <Input
              size="large"
              placeholder=""
              value={deviceInfo.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              
            />
            {validationErrors.name && (
              <p style={{ color: "red", marginTop: 5 }}>
                {validationErrors.name}
              </p>
            )}
            {shouldRenderComponent ? (
              <span style={{ marginBottom: 12, fontSize: "14px" }}>
                Eg Gateway:IMEI
              </span>
            ) : (
              <span className="asset-page-sub-description">
                Eg BIN: SERIAL NUM
              </span>
            )}
          </div>
        </Grid2>

        <Grid2 item xs={12}>
          <div>
            <span className="input-label-user">Description/Notes</span>
            <Input
              size="large"
              placeholder=""
              value={deviceInfo.description}
              onChange={(e) => handleInputChange("description", e.target.value)}
            />
            {validationErrors.description && (
              <p style={{ color: "red", marginTop: 5 }}>
                {validationErrors.description}
              </p>
            )}
          </div>
        </Grid2>

        <Grid2 item xs={12}>
          <div>
            <span className="font-face-vzb page-sub-heading-user">
              Configuration
            </span>
          </div>
        </Grid2>

        <Grid2 item xs={12}>
          <div>
            <span className="input-label-user">Device Model</span>
            {selectedDevice === null ? (
              <Select
                placeholder=""
                style={{ width: "100%" }}
                allowClear
                size="large"
                value={"ts.device.ble"}
                onChange={(value) => handleInputChange("deviceType", value)}
              >
                <Option value="ts.device.ble">BLE Tag</Option>
              </Select>
            ) : (
              <Select
                placeholder=""
                style={{ width: "100%" }}
                allowClear
                value={
                  deviceInfo.kind === "ts.device.ble" ? "BLE Tag" : "GATEWAY"
                }
                size="large"
                disabled
              ></Select>
            )}
            <span className="asset-page-sub-description">
              Device model cannot be changed for existing devices
            </span>
          </div>
        </Grid2>
        {(selectedDevice === null ||
          selectedDevice?.kind === "ts.device.ble") && (
          <Grid2 item xs={12}>
            {/* <div>
              <span className="input-label-user">Asset Type</span>
              <Select
                placeholder=""
                style={{ width: "100%" }}
                allowClear
                value={deviceInfo.assetType}
                onChange={(value) => handleInputChange("assetType", value)}
                size="large"
              >
                <Option value="BIN">BIN</Option>
                <Option value="CAN">CAN</Option>
                <Option value="HOSE">HOSE</Option>
                <Option value="POD">POD</Option>
              </Select>
              {validationErrors.assetType && (
                <p style={{ color: "red", marginTop: 5 }}>
                  {validationErrors.assetType}
                </p>
              )}
              <span className="asset-page-sub-description">
                Applies to BLE Tags Only
              </span>
            </div> */}
          </Grid2>
        )}

        {shouldRenderComponent && (
          <Grid2 item xs={12}>
            <div>
              <span className="input-label-user">
                Target device profile(QUEUED)
              </span>
              <Select
                placeholder=""
                style={{ width: "100%" }}
                allowClear
                value={deviceInfo.targetDeviceProfile}
                onChange={(value) =>
                  handleInputChange("targetDeviceProfile", value)
                }
                size="large"
              >
                <Option value="Mobile">Mobile Gateway</Option>
                <Option value="Fixed">Fixed Gateway</Option>
              </Select>
              <span className="asset-page-sub-description">
                Applies to GATEWAY devices only. Queues the selected profile to
                be pushed to the device
              </span>
              {validationErrors.targetDeviceProfile && (
                <p style={{ color: "red", marginTop: 5 }}>
                  {validationErrors.targetDeviceProfile}
                </p>
              )}
            </div>
          </Grid2>
        )}

        <Grid2
          container
          marginTop={-1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-3">
              <Button
                className="custom-button-cancel"
                type="default"
                onClick={onClose}
                shape="round"
                style={{ fontWeight: "bold", width: "100%" }}
                size={"large"}
              >
                <div style={{ fontFamily: "VerizonNHGDS" }}>Cancel</div>
              </Button>
            </div>
          </Grid2>

          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-3">
              <Button
                className="custom-button-save"
                type="primary"
                onClick={handleClick}
                shape="round"
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                }}
                size={"large"}
              >
                <span style={{ fontFamily: "VerizonNHGDS" }}>
                  {selectedDevice === null ? "Add" : "Update"}
                </span>
              </Button>
            </div>
          </Grid2>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default EditDevice;
